import React, { useState, useContext } from "react";
import Homheader from "../../Components/HomHeader/Homheader";
import ForFooter from "../../Components/ForFooter/ForFooter";
// import classes from "./Home.module.css";
import classes from "./Darkhome.module.css";

import Greenb1 from "../../Assets/GradientBlur.png";
import Greenb2 from "../../Assets/Background (4)green.png";
import Watchicon from "../../Assets/watchicon.png";
import Watchicondark from "../../Assets/videoimg.svg";
import ArrowRight from "../../Assets/ArrowRight.png";
import CountUp from "./CountUp";
import Security from "../../Assets/BankingSecurity.png";
import GlobalAcces from "../../Assets/Global.png";
import Promixmobile from "../../Assets/Promix Mobile App.png";
import Greenchart from "../../Assets/ChartIcon.png";
import purplelock from "../../Assets/LockIcon.png";
import GreenStar from "../../Assets/Greenstar.png";
import BlueChart from "../../Assets/Pnl.png";
import OrangeGlobe from "../../Assets/OrangeGlobe.png";
import Purpleshield from "../../Assets/PurpleShield.png";
import GreenStar1 from "../../Assets/realgreenstar.png";
import checkmark from "../../Assets/Checkmark.png";
import RealtimeSync from "../../Assets/SyncCharge.png";
import RealtimeSync1 from "../../Assets/Background+Shadow+OverlayBlur.svg";
import bluestar from "../../Assets/Bleustar.png";
import purplepnl from "../../Assets/Purplepnl.png";
import Scalengrow from "../../Assets/Scalengrow.png";
import greenarrow from "../../Assets/greenarrowsvg.png";
import checkmarkwhite from "../../Assets/whitecheckmarkdes.png";
import flipper from "../../Assets/flipper.png";
import Checkthemark from "../../Assets/checkmarker.svg";
import { Sun, Moon } from "lucide-react"; // icon library you're already using

import { ThemeContext } from "../../ThemeContext"; // adjust path
import lightClasses from "./Home.module.css";
import darkClasses from "./Darkhome.module.css";
import Whiteimg from "../../Assets/whiteblur.png";
import phoneoverlay from "../../Assets/Gradient+Border+Shadow+OverlayBlur.svg";
import phoneoverlaywhite from "../../Assets/Gradient+Border+Shadow+OverlayBlur.svg";
import { Link } from "react-router-dom";

const Home = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const classes = theme === "dark" ? darkClasses : lightClasses;

  const [activeIndex, setActiveIndex] = useState(null);
  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How quickly can I get started with Promix?",
      answer:
        "You can get started within minutes by signing up and connecting your account.",
    },
    {
      question: "Is my financial data secure?",
      answer:
        "Absolutely. We use bank-level encryption and best security practices.",
    },
    {
      question: "Can I migrate from my current accounting software?",
      answer:
        "Yes, you can easily import data from other platforms using our tools or support.",
    },
    {
      question: "What if I need help or have questions?",
      answer:
        "Our support team is available 24/7 to assist you via email or live chat.",
    },
  ];
  const features = [
    {
      id: "01",
      title: "Quick Setup",
      description:
        "Connect your bank accounts and import existing data in minutes, not hours",
      icon: RealtimeSync1,
    },
    {
      id: "02",
      title: "Smart Automation",
      description:
        "AI-powered categorization and reconciliation handles 90% of your bookkeeping automatically",
      icon: bluestar,
    },
    {
      id: "03",
      title: "Real-time Insights",
      description:
        "Get instant financial reports and analytics to make informed business decisions",
      icon: purplepnl,
    },
    {
      id: "04",
      title: "Scale & Grow",
      description:
        "Seamlessly handle increased transaction volume as your business expands",
      icon: Scalengrow,
    },
  ];
  const cardData = [
    {
      icon: GreenStar1,
      badgeTitle: "90%",
      badgeText: "Less Manual Work",
      title: "AI-Powered Automation",
      desc: "Reduce manual work by 90% with intelligent transaction categorization, automated reconciliation, and smart expense tracking that learns from your business patterns.",
      features: [
        "Smart categorization",
        "Auto-reconciliation",
        "Expense tracking",
        "Pattern learning",
      ],
    },
    {
      icon: BlueChart,
      badgeTitle: "Real-time",
      badgeText: "Financial Insights",
      title: "Real-Time Financial Intelligence",

      desc: "Get instant insights with live dashboards, predictive analytics, and customizable reports that help you make data-driven decisions faster than ever.",
      features: [
        "Live dashboards",
        "Predictive analytics",
        "Custom reports",
        "Data visualization",
      ],
    },
    {
      icon: Purpleshield,
      badgeTitle: "SOC 2",
      badgeText: "Type II Certified",
      title: "Enterprise-Grade Security",
      desc: "Your data is protected with bank-level encryption, SOC 2 Type II compliance, and advanced threat detection that exceeds industry standards.",
      features: [
        "256-bit encryption",
        "SOC 2 compliance",
        "Threat detection",
        "Audit trails",
      ],
    },
    {
      icon: OrangeGlobe,
      badgeTitle: "500+",
      badgeText: "Integrations",
      title: "Seamless Integrations",
      desc: "Connect with 500+ business tools including banks, payment processors, CRM systems, and e-commerce platforms in just one click.",
      features: [
        "Bank connections",
        "Payment processors",
        "CRM integration",
        "E-commerce sync",
      ],
    },
  ];
  const styles = {
    position: "fixed",
    left: "2%",
    bottom: "4%",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: theme === "dark" ? "#1e1e1e" : "#f0f0f0",
    color: theme === "dark" ? "#ffffff" : "#333333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",
    zIndex: 9999,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    transition:
      "background-color 0.3s ease, transform 0.2s ease, color 0.3s ease",
  };

  return (
    <div className={classes.homebody}>
      <Homheader />
      <section className={classes.section_1}>
        <button
          style={styles}
          onClick={toggleTheme}
          title={`Switch to ${theme === "light" ? "Dark" : "Light"} Mode`}
        >
          {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
        </button>
        <img className={classes.imgbg} src={Greenb1} alt="blurr" />
        <img className={classes.imgbg2} src={Greenb2} alt="blurr" />
        <img className={classes.imgbg3} src={Greenb2} alt="blurr" />
        <div className={classes.section1_center}>
          <div className={classes.section1_border}>
            <div className={classes.section1_hold}>
              <img style={{ width: "9px" }} src={Greenb2} alt="Greenball" />
              <p>Trusted by 10,000+ businesses worldwide</p>
              <img src={GreenStar} alt="Starr" />
            </div>
          </div>
          <div className={classes.section1_hero}>
            <h3>Seamless Accounting Software</h3>
            <h4>For SMEs</h4>
            <p>
              Automate your accounting management system today. Our software
              solutions will help streamline account management within Nigeria.
            </p>
          </div>
          <div className={classes.section1_btn}>
            <Link to="/signup">
              {" "}
              <button className={classes.animatedButton} type="button">
                <p>Start Free Trial</p>
                <img src={ArrowRight} alt="inter" />
              </button>
            </Link>

            <button className={classes.watchButton} type="button">
              <img
                src={theme === "dark" ? Watchicondark : Watchicon}
                alt="Promix Logo"
                className={classes.logo}
              />{" "}
              <p>Watch Demo</p>
            </button>
          </div>
          <div className={classes.section1_cards}>
            <div className={classes.cardCont}>
              <h3>
                <CountUp value="10k" />
              </h3>
              <p style={{ marginTop: "-12px" }}>Active Business</p>
            </div>
            <div className={classes.cardCont}>
              <h3>
                <CountUp value="₦50B+" />
              </h3>
              <p style={{ marginTop: "-12px" }}>Active Business</p>
            </div>
            <div className={classes.cardCont}>
              <h3>
                <CountUp value="99.9%" />
              </h3>
              <p style={{ marginTop: "-12px" }}>Active Business</p>
            </div>
            <div className={classes.cardCont}>
              <h3>
                <CountUp value="40hrs" />
              </h3>
              <p style={{ marginTop: "-12px" }}>Active Business</p>
            </div>
          </div>
        </div>
      </section>
      <hr className={classes.hr1} />
      <section className={classes.section_2}>
        <section className={classes.financialSection}>
          <div className={classes.leftContent}>
            <button className={classes.badge}>Product Showcase</button>
            <h2 className={classes.heading}>
              Your entire financial <span>ecosystem in one place</span>
            </h2>
            <p className={classes.description}>
              Access powerful accounting tools from anywhere. Our mobile-first
              design ensures you stay connected to your business finances
              whether you're in the office or on the go.
            </p>
            <div className={classes.features}>
              <div className={classes.featureItem}>
                <img src={RealtimeSync} alt="Real-time Sync" />
                <div>
                  <h4>Real-time Sync</h4>
                  <p>Instant updates across all devices</p>
                </div>
              </div>
              <div className={classes.featureItem}>
                <img src={Security} alt="Bank-level Security" />
                <div>
                  <h4>Bank-level Security</h4>
                  <p>256-bit encryption & SOC 2 compliance</p>
                </div>
              </div>
              <div className={classes.featureItem}>
                <img src={GlobalAcces} alt="Global Access" />
                <div>
                  <h4>Global Access</h4>
                  <p>Work from anywhere, anytime</p>
                </div>
              </div>
            </div>
            <Link to="/signup">
              {" "}
              <button className={classes.animatedButton} type="button">
                <p>Start Free Trial</p>
                <img src={ArrowRight} alt="inter" />
              </button>{" "}
            </Link>
          </div>

          <div className={classes.rightContent}>
            <img
              src={Promixmobile}
              alt="Promix App"
              className={classes.mobileApp}
            />
            <img
              src={theme === "dark" ? phoneoverlaywhite : phoneoverlay}
              alt="Promix Logo"
              className={classes.mobileApp_overlay}
            />

            <img
              src={Greenchart}
              alt="Chart Icon"
              className={`${classes.icon} ${classes.iconGreen}`}
            />
            <img
              src={purplelock}
              alt="Lock Icon"
              className={`${classes.icon} ${classes.iconPurple}`}
            />
            <img
              src={BlueChart}
              alt="Blue Chart Icon"
              className={`${classes.icon} ${classes.iconBlue}`}
            />
          </div>
        </section>
      </section>
      <section className={classes.section_3}>
        <img className={classes.imgbg_r1} src={Greenb1} alt="blurr" />
        <div className={classes.top}>
          <center className={classes.center1}>
            {" "}
            <button className={classes.badge}>Product Showcase</button>
          </center>
          <h2 className={`${classes.heading} ${classes.tedClass}`}>
            Built for the modern <span>finance team</span>
          </h2>

          <p
            className={`${classes.description} ${classes.extraDescriptionClass}`}
          >
            Experience the next generation of accounting software designed for
            speed, accuracy, and growth.
          </p>
        </div>
        <div className={classes.cardGrid}>
          {cardData.map((item, index) => (
            <div
              key={index}
              className={`${classes.card} ${classes["hover" + index]}`}
            >
              <img src={item.icon} alt="icon" className={classes.icon_r} />
              <div className={classes.badge1}>
                <div className={classes.badgeTitle}>{item.badgeTitle}</div>
                <div className={classes.badgeText}>{item.badgeText}</div>
              </div>
              <h3 className={classes.title_r}>{item.title}</h3>
              {item.desc && <p className={classes.description}>{item.desc}</p>}
              <ul className={classes.featureList}>
                {item.features.map((molly, i) => (
                  <li key={i}>
                    <img
                      src={checkmark}
                      alt="check"
                      className={classes.checkIcon}
                    />
                    {molly}
                  </li>
                ))}
              </ul>
              <a href="#" className={classes.learnMore}>
                Learn more <span>→</span>
              </a>
            </div>
          ))}
        </div>

        <div className={classes.lastrank}>
          <div className={classes.lastP}>
            <div className={classes.comment1}>
              <h3>
                "Promix transformed our entire finance operation in just 30
                days"
              </h3>
              <p>
                "We reduced our month-end close from 15 days to just 3 days. The
                AI-powered reconciliation saves us 40+ hours monthly, and the
                real-time insights have completely changed how we make financial
                decisions."
              </p>
              <group>
                <span className={classes.initials}>AO</span>
                <span className={classes.initials_name}>
                  <span>Adebayo Ogundimu</span>
                  <p>CFO, TechCorp Nigeria</p>
                </span>
              </group>
            </div>
            <div className={classes.comment2}>
              <div className={classes.covers}>
                <div className={classes.covers1}>
                  <h2>15→3</h2>
                  <p style={{ marginTop: "-11px" }}>Days to close</p>
                </div>
                <div className={classes.covers1}>
                  <h2>40hrs</h2>
                  <p style={{ marginTop: "-11px" }}>Saved Monthly</p>
                </div>
                <div className={classes.covers1}>
                  <h2>₦8M</h2>
                  <p style={{ marginTop: "-11px" }}>Annual savings</p>
                </div>
                <div className={classes.covers1}>
                  <h2>100%</h2>
                  <p style={{ marginTop: "-11px" }}>Accuracy rate</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.howitworks}>
        <div className={classes.top}>
          <center className={classes.center1}>
            {" "}
            <button className={classes.badge}>How it works</button>
          </center>
          <h2 className={`${classes.heading} ${classes.tedClass}`}>
            Get started in <span>under 15 minutes</span>
          </h2>

          <p
            className={`${classes.description} ${classes.extraDescriptionClass}`}
          >
            Our intelligent onboarding process gets you up and running faster
            than any other accounting platform.
          </p>
        </div>
        <div className={classes.featureGrid}>
          {features.map((molly) => (
            <div
              key={molly.id}
              className={`${classes.featureCard} ${
                classes["featureHover" + molly.id]
              }`}
            >
              <div className={classes.featureBadge}>{molly.id}</div>
              <div className={classes.featureIcon}>
                <img src={molly.icon} alt={molly.title} />
              </div>
              <h3 className={classes.featureTitle}>{molly.title}</h3>
              <p className={classes.featureDescription}>{molly.description}</p>
            </div>
          ))}
        </div>
        <div className={classes.blackbg}>
          {" "}
          <div className={classes.blackbg1}>
            <h3>Ready to revolutionize your accounting?</h3>
            <p style={{ marginTop: "-24px" }}>
              Join thousands of businesses already saving time and money. Start
              your free trial today.
            </p>
            <Link to="/signup">
              <button
                className={`${classes.animatedButton} ${classes.ctaPrimary}`}
                type="button"
              >
                <p>Start Free Trial</p>
                <img src={greenarrow} alt="arrow icon" />
              </button>
            </Link>

            <group1>
              <span className={classes.le}>
                <img
                  className={classes.iconcheck}
                  src={checkmarkwhite}
                  alt=""
                />
                <p style={{ fontSize: "12px" }} className={classes.smalling}>
                  30-day free trial
                </p>
              </span>
              <span className={classes.le}>
                <img
                  className={classes.iconcheck}
                  src={checkmarkwhite}
                  alt=""
                />
                <p style={{ fontSize: "12px" }} className={classes.smalling}>
                  No credit card required
                </p>
              </span>
              <span className={classes.le}>
                <img
                  className={classes.iconcheck}
                  src={checkmarkwhite}
                  alt=""
                />
                <p className={classes.smalling} style={{ fontSize: "12px" }}>
                  Setup in 15 minutes
                </p>
              </span>
            </group1>
          </div>
        </div>
      </section>
      <section className={classes.pricecards}>
        <div className={classes.top}>
          <center className={classes.center1}>
            {" "}
            <button className={classes.badge}>Pricing</button>
          </center>
          <h2 className={`${classes.heading} ${classes.tedClass}`}>
            Simple, transparent <span>pricing for everyone</span>
          </h2>

          <p
            className={`${classes.description} ${classes.extraDescriptionClass}`}
          >
            Choose the plan that fits your business size and needs. Upgrade or
            downgrade anytime.{" "}
          </p>
        </div>
        <div className={classes.pricingWrapUnique24}>
          <div className={classes.cardBoxZeta1}>
            <h2 className={classes.planHeaderZeta1}>Starter</h2>
            <p className={classes.planCostZeta1}>
              <span className={classes.nairaTagZeta1}>₦</span>0
              <span className={classes.billingCycleZeta1}>/month</span>
            </p>
            <p className={classes.descriptionZeta1}>
              Perfect for freelancers and solo entrepreneurs
            </p>
            <ul className={classes.featureListZeta1}>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                1 User
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Basic Reporting
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Bank Sync
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Mobile App
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Email Support
              </li>
            </ul>
            <Link to="/signup">
              <button className={classes.ctaGrayZeta1}>Start Free</button>
            </Link>
          </div>

          <div
            className={`${classes.cardBoxZeta1} ${classes.highlightCardZeta1} ${classes.cardBoxZeta1Large}`}
          >
            <div className={classes.ribbonBadgeZeta1}>Most Popular</div>
            <h2 className={classes.planHeaderZeta1}>Professional</h2>
            <p className={classes.planCostZeta1}>
              <span className={classes.nairaTagZeta1}>₦</span>50,000
              <span className={classes.billingCycleZeta1}>/year</span>
            </p>
            <p className={classes.descriptionZeta1}>
              Ideal for growing businesses and small teams
            </p>
            <ul className={classes.featureListZeta1}>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                5 Users
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Advanced Reports
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Multi-currency
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                API Access
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Priority Support
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Custom Integrations
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Automated Workflows
              </li>
            </ul>
            <Link to="/signup">
              <button className={classes.ctaGreenZeta1}>Choose Pro</button>
            </Link>
          </div>

          <div className={classes.cardBoxZeta1}>
            <h2 className={classes.planHeaderZeta1}>Enterprise</h2>
            <p className={classes.planCostZeta1}>
              <span className={classes.nairaTagZeta1}>₦</span>120,000
              <span className={classes.billingCycleZeta1}>/year</span>
            </p>
            <p className={classes.descriptionZeta1}>
              For established businesses with complex needs
            </p>
            <ul className={classes.featureListZeta1}>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Unlimited Users
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                White-label Options
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Advanced Security
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Dedicated Manager
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                Custom Training
              </li>
              <li>
                <img
                  src={checkmark}
                  alt="check"
                  className={classes.iconPulseZeta1}
                />{" "}
                SLA Guarantee
              </li>
            </ul>
            <button className={classes.ctaGrayZeta1}>Contact Sales</button>
          </div>
        </div>
      </section>
      <section className={classes.accordionhead}>
        <div className={classes.top}>
          <center className={classes.center1}>
            {" "}
            <button className={classes.badge}>FAQs</button>
          </center>
          <h2 className={`${classes.heading} ${classes.tedClass}`}>
            Questions? <br className={classes.br1} />{" "}
            <span>We have answers</span>
          </h2>
        </div>
        <div className={classes.faqWrapperZyra19}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`${classes.faqItemZyra19} ${
                activeIndex === index ? classes.activeZyra19 : ""
              }`}
              onClick={() => toggleIndex(index)}
            >
              <div className={classes.faqQuestionZyra19}>
                <span>{faq.question}</span>
                <img
                  src={flipper}
                  alt="Toggle"
                  className={`${classes.chevronZyra19} ${
                    activeIndex === index ? classes.rotateZyra19 : ""
                  }`}
                />
              </div>
              {activeIndex === index && (
                <div className={classes.faqAnswerZyra19}>{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
      <div className={classes.blackbg3}>
        <div className={classes.blackbg2}>
          {/* <img className={classes.blur12} src={Whiteimg} alt="/" /> */}
          <h3>Ready to revolutionize your accounting?</h3>
          <p style={{ marginTop: "-24px" }}>
            Join thousands of businesses already saving time and money. Start
            your free trial today.
          </p>
          <Link to="/signup">
            {" "}
            <button
              className={`${classes.animatedButton} ${classes.ctaPrimary1}`}
              type="button"
            >
              <p className={classes.pgreen} style={{ color: "green" }}>
                Start Free Trial
              </p>{" "}
              <img src={greenarrow} alt="arrow icon" />
            </button>
          </Link>

          <group2 className={classes.cardContainer}>
            <span className={classes.darkcard}>
              <img src={Checkthemark} alt="checkmark" />
              <p className={classes.cardTitle}>30-Day Free Trial</p>
              <p className={classes.cardSub}>No credit card required</p>
            </span>
            <span className={classes.darkcard}>
              <img src={Checkthemark} alt="checkmark" />
              <p className={classes.cardTitle}>Enterprise Security</p>
              <p className={classes.cardSub}>Bank-level protection</p>
            </span>
            <span className={classes.darkcard}>
              <img src={Checkthemark} alt="checkmark" />
              <p className={classes.cardTitle}>Expert Support</p>
              <p className={classes.cardSub}>24/7 assistance</p>
            </span>
          </group2>
        </div>
      </div>
      <footer>
        <ForFooter />
      </footer>
    </div>
  );
};

export default Home;
